module.exports = __webpack_public_path__ + "media/images/flags/4x3/aia-fd3ffd237b95c6f0e401b8ec3bf95025.svg";